import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CommuneModel } from 'src/models/commune.model';

@Injectable({
  providedIn: 'root'
})
export class CommmuneService {
  private communesSubject: BehaviorSubject<Array<CommuneModel>>;
  public communes$: Observable<Array<CommuneModel>>;
  private cachedCommunes: CommuneModel[] | null = null;

  constructor(private http: HttpClient) {
    this.communesSubject = new BehaviorSubject<Array<CommuneModel>>([]);
    this.communes$ = this.communesSubject.asObservable();
  }

  public get value(): Array<CommuneModel> {
    return this.communesSubject.value;
  }

  update(communes: Array<CommuneModel>){
    this.cachedCommunes = communes;
    this.communesSubject.next(communes);
  }

  list(): Observable<Array<CommuneModel>> {
    if (this.cachedCommunes) {
      console.log('Returning cached communes');
      return of(this.cachedCommunes);
    }
    return this.http.get(`${environment.apiUrl}communes/`).pipe(
      tap((data: Array<CommuneModel>) => {
        // Mise à jour du cache
        this.cachedCommunes = data;
        console.log('Communes data cached');
      }),
      shareReplay(1) // Partage la réponse entre plusieurs subscribers
    ) as Observable<Array<CommuneModel>>;
  }


  getCommunesByPrefecture(pk: number) {
    if (this.cachedCommunes) {
      console.log('Returning cached communes');
      return of(this.cachedCommunes);
    }
    return this.http.post(`${environment.apiUrl}communes/get_communes_by_pref/`, {prefecture: pk}).pipe(
      tap((data: Array<CommuneModel>) => {
        // Mise à jour du cache
        this.cachedCommunes = data;
        console.log('Communes data cached');
      }),
      shareReplay(1) // Partage la réponse entre plusieurs subscribers
    ) as Observable<Array<CommuneModel>>;
  }
}
